import React, {useEffect, useState} from 'react'
import ViewTenant from './ViewTenant'
import {Routes, Route, Navigate, Outlet, useParams} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../../_metronic/layout/core'
import TenantOverview from './TenantOverview'
import TenantDocument from './TenantDocument'
import {Get_View_Tenant} from '../Tenant_API'

const profileBreadCrumbs: Array<PageLink> = [
  {title: 'Tenant Details', path: '/tenant', isSeparator: false, isActive: false},
  {title: '', path: '', isSeparator: true, isActive: false},
]
interface tenantDetailsDatatype {
  accouont_holder_name: string
  business_contact_number: string
  business_email_id: string
  business_name: string
  contact_number: string
  created_date: string
  currency_code: string
  email_id: string
  other_deposits: number
  property_rent_due_date: string
  property_rent_end_date: string
  property_rent_rate: number
  property_rent_start_date: string
  property_sub_unit_uuid: string
  property_unit_name: string
  property_usage_type: number
  property_uuid: string
  rental_agreement_date: string
  security_deposit: number
  sub_unit_available: boolean
  tenancy_commencement_date: string
  tenancy_expiration_date: string
  tenancy_term: number
  tenant_account_status: number
  tenant_account_uuid: string
  utilities_deposit: number
}
const ViewTenantRoutes = () => {
  const [tenantDetails, setTenantDetails] = useState<tenantDetailsDatatype>()
  const {id} = useParams()
  const get_view_tenant = async () => {
    if (id) {
      const {data: response} = await Get_View_Tenant(id)
      if (response.code === '200') {
        setTenantDetails(response.data[0])
      }
    }
  }
  useEffect(() => {
    get_view_tenant()
  }, [])

  const dateSuperScript = (date: string) => {
    switch (date) {
      case '1':
        return 'st'
      case '2':
        return 'nd'
      case '3':
        return 'rd'
      default:
        return 'th'
    }
  }
  return (
    <>
      <Routes>
        <Route
          element={
            <>
              <ViewTenant tenantDetails={tenantDetails} get_view_tenant={get_view_tenant} id={id} dateSuperScript={dateSuperScript}/>
              <Outlet />
            </>
          }
        >
          <Route
            path='overview'
            element={
              <>
                {/* <PageTitle breadcrumbs={profileBreadCrumbs}>Overview</PageTitle> */}
                <PageTitle>Overview</PageTitle>
                <TenantOverview
                  tenantDetails={tenantDetails}
                  get_view_tenant={get_view_tenant}
                  id={id}
                  dateSuperScript={dateSuperScript}
                />
              </>
            }
          />
          <Route
            path='documents'
            element={
              <>
                {/* <PageTitle breadcrumbs={profileBreadCrumbs}>Documents</PageTitle> */}
                <PageTitle>Documents</PageTitle>
                <TenantDocument tenantDetails={tenantDetails} id={id} />
              </>
            }
          />
        </Route>

        <Route index element={<Navigate to={`/tenant/${id}/overview`} />} />
        <Route path='*' element={<Navigate to='/404' />} />
      </Routes>
    </>
  )
}

export default ViewTenantRoutes
